<template>
	<div id="cuenta-page" v-if="user">
		<div class="container container-sm">
			<aside>
				<nav>
					<router-link :to="{ name: 'informacion-personal' }" class="item-cuenta">
						<i class='bx bx-user'></i>
						<span>Mi cuenta</span>
					</router-link>
					<router-link :to="{ name: 'mis-tickets' }" class="item-cuenta">
						<i class='bx bx-qr' ></i>
						<span>Mis tickets</span>
					</router-link>
					<router-link :to="{ name: 'mis-amigos' }" class="item-cuenta">
						<i class='bx bxs-face'></i>
						<span>Mis amigos</span>
					</router-link>
					<router-link :to="{ name: 'notificaciones-seguridad' }" class="item-cuenta">
						<i class='bx bx-bell'></i>
						<span>Notificaciones y seguridad</span>
					</router-link>
				</nav>
				<a href="" @click.prevent="logout" class="cerrar-sesion">
					<i class="bx bx-log-out"></i>
					<span>Cerrar sesión</span>
				</a>
			</aside>
			<div class="cuenta-content">
				<router-view name="cuenta"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapActions } from "vuex";
	import { createNamespacedHelpers } from 'vuex';
	const { mapState } = createNamespacedHelpers('AuthModule');

	export default {
		computed: {
			...mapState({
				user: state => state.user	
			}),
			...mapActions('AuthModule', ['logout']),
		},
		async mounted(){
			if(!this.user){
				this.logout();
			}
		},
		metaInfo: {
			title: 'Mi cuenta',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
	}
</script>

<style lang="scss" scoped>
	#cuenta-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 60px 0px;

		.container{
			@include flex(row, flex-start, flex-start);

			aside{
				width: 280px;
				margin-right: 40px;
				@include flex(column, flex-start, flex-start);

				nav{
					width: 100%;
					border-radius: 12px;
					// padding: 10px;
					margin-bottom: 20px;
					// border: 1px solid rgb(221, 221, 221);
					// box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;
					@include flex(column, flex-start, flex-start);

					.item-cuenta {
						@include flex(row, flex-start, center);
						padding: 15px 15px;
						cursor: pointer;
						border-radius: 0;
						width: 100%;
						border: 1px solid #dddddd;
						box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.05);
						text-decoration: none;
						border-radius: 8px;
						margin: 5px 0px;
						color: var(--color-darker);

						i {
							font-size: 16px;
							margin-right: 6px;
							line-height: 1em;
						}

						span {
							font-size: 14px;
							line-height: 1em;
							font-weight: var(--fw-500);
						}

						&:hover {
							// border: none;
							// background: rgba(0, 0, 0, 0.05);
							background-color: var(--color-darker);

							i,span{
								color: var(--color-white);
							}
						}
					}
				}

				.cerrar-sesion{
					@include flex(row, center, center);
					text-decoration: none;
					color: var(--color-darker);
					padding-left: 10px;
					cursor: pointer;
					@include transition(all .2s);

					i {
						font-size: 16px;
						margin-right: 6px;
						line-height: 1em;
					}

					span {
						font-size: 14px;
						line-height: 1em;
						font-weight: var(--fw-400);
					}

					&:hover{
						color: var(--color-red-error);
					}
				}
			}

			.cuenta-content{
				width: calc(100% - 320px);
				@include flex(column, flex-start, flex-start);
			}
		}
	}

	@media screen and (max-width: 1400px){
		#cuenta-page{
			padding: 30px 0px;

			.container{
				padding-left: 24px;
				padding-right: 24px;
			}
		}
	}

	@media screen and (max-width: 840px){
		#cuenta-page{
			.container{
				@include flex(column, flex-start, flex-start);

				aside{
					order: 2;
					width: 100%;
					margin-right: 0px;
					margin-top: 20px;
					margin-bottom: 0px;

					.cerrar-sesion{
						display: none;
					}
				}

				.cuenta-content{
					width: 100%;
				}
			}
		}
	}

	@media screen and (max-width: 600px){
		#cuenta-page{
			.container{
				aside{
					margin-bottom: 10px;

					nav{
						.item-cuenta{
							padding: 12px;
							
							i{
								font-size: 15px;
							}

							span{
								font-size: 13px;
							}
						}
					}
				}
			}
		}
	}
</style>